import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/3_red/3_red"
 * Contains 1 texture(s)
 */
export class Tablet3RedAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/3_red/3_red';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '3_red.png'
    ] as const;
}
